export const CashFlowCategory = {
  Custom: 0,
  Labor: 1,
  Hardware: 2,
  Software: 3,
  Licenses: 4,
  "One Time Charges": 5,
  "Recurrent Charges": 6,
  "Travel & Expenses": 7,
  Representations: 8,
};

export const getCategoryName = (categoryId) => {
  return (
    Object.entries(CashFlowCategory).find(
      ([_, value]) => value === categoryId
    )?.[0] || "Unknown"
  );
};
